import ErrorFallback from "./ErrorFallback";

function ErrorBoundary() {
  return <ErrorFallback />;
}

export { ErrorBoundary };
